import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, spacing, common } = THEME;
const borderRadius = common.borderRadius;

export const conditionalOptionsSectionStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		padding: `${spacing.md}px 0 ${spacing.lg}px`,
		borderTop: `1px solid ${colors.border.light}`,
		marginTop: spacing.sm,
	},
	containerDisabled: {
		opacity: 0.72,
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: spacing.md,
	},
	headerText: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		minWidth: 0,
	},
	heading: {
		fontSize: 13,
		fontWeight: 600,
		color: colors.text.main,
		margin: 0,
	},
	description: {
		fontSize: 12,
		lineHeight: '16px',
		color: colors.text.light,
		margin: 0,
	},
	optionsGrid: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	optionCard: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		padding: spacing.md,
		border: `1px solid ${colors.border.light}`,
		borderRadius,
		backgroundColor: colors.background.light,
		transition: 'border-color 120ms ease, box-shadow 120ms ease, background-color 120ms ease',
	},
	optionCardSelected: {
		borderColor: colors.primary.main,
		boxShadow: `0 0 0 1px ${colors.primary.main}`,
		backgroundColor: colors.hover.light,
	},
	optionCardDisabled: {
		backgroundColor: colors.background.main,
	},
	optionCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: spacing.sm,
	},
	optionControlRow: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: spacing.sm,
		flex: 1,
		minWidth: 0,
	},
	optionContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		cursor: 'pointer',
		minWidth: 0,
	},
	optionTitle: {
		fontSize: 13,
		fontWeight: 600,
		color: colors.text.main,
	},
	optionDescription: {
		fontSize: 12,
		lineHeight: '16px',
		color: colors.text.light,
	},
	timeoutEditor: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		padding: spacing.md,
		backgroundColor: colors.background.main,
		border: `1px solid ${colors.border.light}`,
		borderRadius,
	},
	timeoutHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: spacing.sm,
	},
	timeoutLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: colors.text.main,
		margin: 0,
	},
	timeoutHint: {
		fontSize: 12,
		lineHeight: '16px',
		color: colors.text.light,
		margin: `${spacing.xs}px 0 0`,
	},
	timeoutControls: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		flexWrap: 'wrap',
	},
	timeoutInputLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: colors.text.main,
	},
	timeoutInputGroup: {
		width: 148,
	},
	updatingMessage: {
		fontSize: 12,
		color: colors.text.light,
		margin: 0,
	},
	feedbackMessage: {
		fontSize: 12,
		lineHeight: '16px',
		color: colors.danger.dark,
		margin: 0,
		backgroundColor: '#FEF2F2',
		border: `1px solid ${colors.danger.main}`,
		borderRadius,
		padding: `${spacing.sm}px ${spacing.md}px`,
	},
	disabledWarning: {
		fontSize: 12,
		lineHeight: '16px',
		color: colors.warning.dark,
		margin: 0,
		backgroundColor: colors.warning.light,
		border: `1px solid ${colors.warning.main}`,
		borderRadius,
		padding: `${spacing.sm}px ${spacing.md}px`,
	},
});
